import {Icon, styled, Typography} from '@innowise-group/ui-kit';

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.5rem;
  position: relative;
  border-radius: 0.5rem;
  border: ${({theme}) => `1px solid ${theme.palette.specials.meetings.border}`};

  @media (max-width: 768px) {
    gap: 0;
  }

  @media (max-width: 480px) {
    padding: 0.25rem;
  }
`;

export const InfoIcon = styled(Icon)`
  position: absolute;
  top: 0.5rem;

  @media (max-width: 480px) {
    top: 0.125rem;
  }
`;
export const InfoTextWithIndent = styled(Typography)`
  color: ${({theme}) => theme.palette.general.darkGrey[100]};
  font-family: Manrope;
  font-style: normal;
  font-weight: 400;
  line-height: 137.5%;
  letter-spacing: 0.04px;
  margin: 0;
  text-indent: 1.5625rem;

  @media (max-width: 768px) {
    font-size: 0.875rem;
  }

  @media (max-width: 650px) {
    font-size: 0.8rem;
  }

  @media (max-width: 480px) {
    font-size: 0.625rem;
  }
`;
